const FB_SDK_INIT_DATA = 'fbSdkInitialized';
const FB_APP_ID_DATA = 'fbAppId';
const FB_PRIVACY_SETTINGS_HASH = 'facebook-privacy';
const ERROR_PAGE = '/accedi?error';
const FB_API_VERSION = 'v3.2';
const LOCATION_KEY = 'fb_location_name';

const redirectToError = function fbRedirectToError() {
    window.location.href = ERROR_PAGE;
};


const refreshPage = function fbRefreshPage(isFirstLogin) {
    if(isFirstLogin) {
        window.location.href = localStorage.getItem(LOCATION_KEY) + '#' + FB_PRIVACY_SETTINGS_HASH;
    } else {
        window.location.href = localStorage.getItem(LOCATION_KEY);
    }
};

export default class FacebookLogin {
    constructor(gtm, element) {
        this.config = {
            tokenUrl: '/login/facebook',
            facebookScope: 'public_profile,email'
        };
        this.csrfToken = $('meta[name="_csrf"]').attr('content');
        this.gtm = gtm || { trackEvent: function () { } };
        this.$element = $(element);
    }

    init() {
        this.$element.on('click', $.proxy(this, 'login'));

        if ($(document).data(FB_SDK_INIT_DATA) === true) {
            this.$element.removeAttr('disabled');
            return;
        }

        this.loadSdk();

        $(document).data(FB_SDK_INIT_DATA, true);

        // coming from the web auth, logging event and to auth service...
        const token = this.hasAccessToken();

        if(token) {
            this.sendToken(token);
        }
    }

    loadSdk() {
        // Load the SDK asynchronously
        $.ajax({
            cache: true,
            url: '//connect.facebook.net/it_IT/sdk.js',
            dataType: 'script'
        }).done(() => {            // TODO: decouple these
            window.FB.init({
                appId: this.$element.data(FB_APP_ID_DATA),
                cookie: true,      // enable cookies to allow the server to access the session
                xfbml: true,       // parse social plugins on this page
                version: FB_API_VERSION,
                status: true       // fetch status on page load to prevent popup blocking
            });
            this.$element.removeAttr('disabled');
        });
    }

    login(e) {

        var ua = window.navigator.userAgent;
        var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
        var webkit = !!ua.match(/WebKit/i);
        var iOSSafari = iOS && webkit && !ua.match(/CriOS/i);

        let redirectURI = 'https://' + window.location.hostname + '/login/facebook';
        localStorage.setItem(LOCATION_KEY, location.href.split('#')[0]);

        const facebookUrl = 'https://www.facebook.com/'+ FB_API_VERSION +'/dialog/oauth?state=' + this.csrfToken + '&scope=' + this.config.facebookScope + '&client_id=' + this.$element.data(FB_APP_ID_DATA) + '&response_type=token,granted_scopes&auth_type=rerequest&redirect_uri=' + redirectURI;

        // I hate PWA in Safari Mobile
        if(('standalone' in window.navigator) && window.navigator.standalone && iOSSafari){
            window.open('http://' + window.location.hostname + '#accedi', '_blank');
        } else {
            window.location = facebookUrl;
        }
    }

    sendToken(token) {
        // sends token received from FB to our auth service
        const body = {
            token: token
        };
        $.ajax({
            type: 'POST',
            url: this.config.tokenUrl,
            data: JSON.stringify(body),
            headers: {
                'X-CSRF-Token': this.csrfToken,
                'Content-Type': 'application/json'
            },
            dataType: 'json'
        }).done((response) => {
            this.gtm.trackEvent('LoginSuccess', 'Facebook');
            refreshPage(response.firstLogin);
        }).fail(() => {
            this.gtm.trackEvent('LoginFail', 'Facebook');
            redirectToError();
        });
    }

    hasAccessToken() {
        const hashObj = location.hash.replace('#', '').split('&').reduce((prev, item) => {
            return Object.assign({[item.split('=')[0]]: item.split('=')[1]}, prev);
        }, {});
        return (typeof(hashObj.access_token) ==  'undefined') ? false : hashObj.access_token;
    }
}

module.exports = FacebookLogin;
